import {
    Box,
} from "@chakra-ui/react";

import {
    NavLink as RouterNavLink,
} from "react-router-dom";


const NavLink = ({
    children,
    route,
}) => {

    return (

        <Box
            as={RouterNavLink}

            to={route}

            px={{
                md: 2,
                lg: 3,
            }}

            py={2}

            position="relative"

            fontFamily="'Poppins', sans-serif"

            fontSize={{
                md: "xs",
                lg: "sm",
            }}

            fontWeight="500"

            letterSpacing="0.5px"

            textTransform="uppercase"

            color="gray.700"

            textDecoration="none"

            transition="all 0.2s ease"

            _hover={{
                color: "red.600",
                textDecoration: "none",
            }}

            sx={{
                "&.active": {

                    color: "red.600",

                    fontWeight: "600",

                },

                "&.active::after": {

                    content: '""',

                    position: "absolute",

                    left: "50%",

                    transform:
                        "translateX(-50%)",

                    bottom: "2px",

                    width: "22px",

                    height: "2px",

                    backgroundColor:
                        "#C53030",

                    borderRadius: "full",

                },
            }}
        >

            {children}

        </Box>

    );

};


export default NavLink;